import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
    useTable,
    useGlobalFilter,
    useSortBy,
    usePagination,
  } from "react-table";

export const useCustomTable = ({
  defaultColumns,
  fetchDataFn,
  setSelectAllActive=()=>{},
  setSelectValue=()=>{},
}) => {
  const columns = useMemo(() => defaultColumns, [defaultColumns]);
  const [dataItem, setDataItem] = useState([]);
  const data = useMemo(() => dataItem, [dataItem]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { sortBy },
    setGlobalFilter,
  } = useTable(
    { columns, data, manualSortBy: true },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  //   const resetStoreData = () => {
  //     setPage(0);
  //     setDataItem([]);
  //   };

  //   const fetchData = useCallback(async () => {
  //     setLoading(true);
  //     const data = await fetchDataFn({ page, pageSize, filters, searchQuery, sortBy });
  //     setTotalCount(data.totalItems);
  //     setDataItem((prev) => (page === 0 ? data.rows : [...prev, ...data.rows]));
  //     setLoading(false);
  //   }, [page, filters, searchQuery, sortBy, fetchDataFn]);

  //   useEffect(() => {
  //     fetchData();
  //   }, [page, fetchData]);

  const resetStoreData = () => {
    // setSelectAllActive(false);
    // setSelectValue([]);
    setPage(0);
    setDataItem([]);
  };
  const fetchMoreData = () => {
    if (loading) return;
    setPage(page + 1);
  };

  useEffect(() => {
    return () => {
      setFilters({});
      setSearchQuery("");
      setSelectAllActive(false);
      setSelectValue([]);
      resetStoreData();
    };
  }, []);

  const fetchData = async () => {
    // if (loading) return;
    setLoading(true);
    const getAllData = await fetchDataFn();
    setTotalCount(getAllData.data.totalItems);
    setDataItem((prev) =>
      page === 0
        ? getAllData.data.rows
        : [...prev, ...getAllData.data.rows]
    );
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    setLoading(true);
    if (page === 0) {
      fetchData();
    }
    resetStoreData();
  }, [sortBy, searchQuery, filters]);

  return {
    columns,
    data,
    loading,
    totalCount,
    page,
    setPage,
    dataItem,
    filters,
    setFilters,
    searchQuery,
    setSearchQuery,
    resetStoreData,
    fetchMoreData,
    fetchData,
    filterModalOpen, 
    setFilterModalOpen,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { sortBy },
  };
};
